<template>
  <Modal v-model:isOpen="isActive" header="Eliminar factura" size="is-large" @save="onSubmit">
    <h3>
      Está por eliminar esta factura. Esta acción no se puede deshacer. ¿Está seguro de continuar?
    </h3>
    <template #footer>
      <Button label="Cancelar" variant="danger" :disabled="loading" inverted @click="onCancel" />
      <Button label="Eliminar" variant="danger" :disabled="loading" @click="onDelete" />
    </template>
  </Modal>
</template>

<script setup>
// Imports
import { defineModel } from 'vue';
import { Modal, Button } from '@/components';

// Component Options

// Props and Emits
const props = defineProps({
  data: { type: Object, default: () => {} },
  loading: { type: Boolean, default: false },
});
const isActive = defineModel('active', { type: Boolean, default: false });
const emit = defineEmits(['delete']);

// Composition API Helpers
// Reactive Variables
// Computed Properties
// Watchers
// Lifecycle Hooks

// Methods
const onCancel = () => {
  isActive.value = false;
};

const onDelete = () => {
  emit('delete', props.data.id);
};
</script>
